import createHttp from "../lib/http";

/**
 * Fetches the authenticated user guide PDF as a Blob.
 * 401 is handled globally by the HTTP interceptor (session cleared + redirect).
 */
export async function fetchUserGuidePdfBlob() {
	const response = await createHttp.get("/api/docs/user-guide", {
		responseType: "blob",
	});

	if (!response || response.status === 401) {
		return null;
	}

	if (response.status >= 400) {
		throw new Error("Could not load user guide");
	}

	const blob = response.data;
	if (!(blob instanceof Blob)) {
		throw new Error("Invalid user guide response");
	}

	if (blob.type === "application/json") {
		const text = await blob.text();
		let message = "Could not load user guide";
		try {
			const parsed = JSON.parse(text);
			message = parsed.message || parsed.msg || message;
		} catch {
			// keep default message
		}
		throw new Error(message);
	}

	return blob;
}
